import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    /*read(id?: number) {
      if (id)
        return api.get('categories/' + id).then(category => new Category(category))
      return api.get('categories?order=name')
    }*/
    default_1.prototype.read = function () {
        return api.get("categories?eager=translations&order=name").then(function (categories) {
            return new Promise(function (resolve, reject) {
                var mappedCategories = categories.map(function (c) {
                    var temp = {
                        id: c.id,
                        name: c.name,
                        value: c.translations ? c.translations.reduce(function (previous, current) {
                            if (!previous[current.languageCode.toLowerCase()]) {
                                previous[current.languageCode.toLowerCase()] = current.name;
                            }
                            return previous;
                        }, {}) : c.name
                    };
                    return temp;
                });
                resolve(mappedCategories);
            });
        });
    };
    default_1.prototype.addMultiple = function (value) {
        return api.post('categories/multiple', value);
    };
    default_1.prototype.create = function (data) {
        return api.post('categories', data);
    };
    default_1.prototype.update = function (id, data) {
        return api.put('categories/' + id, data);
    };
    default_1.prototype.delete = function (id) {
        throw new Error('Method not implemented.');
    };
    default_1.prototype.disable = function (id, disabled) {
        throw new Error('Method not implemented.');
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Categories/CategoriesStore.ts
// module id = 752
// module chunks = 0